<template>
  <div
    class="tabs-container embedded-tabs-container d-f jc-c p"
    :class="forSubmitDemoModal ? 'w-100' : 'tabs-padding-y'"
  >
    <div 
      class="w-100"
      :class="{ 'small-wrap': showForm }"
    >
      <form class="d-f fd-c ai-c" @submit.prevent="formSubmitted">
        <!-- tab buttons (hidden for submit demo - goes straight to artist sign up) -->
        <div v-if="!forSubmitDemoModal" class="d-f w-100 bs-bb" :class="{ 'big-select-buttons': !showForm }">
          <div
            v-for="(tab, i) in tabs"
            :key="i"
            class="flex-1 ta-c p-t p-b tab d-f fd-c"
            :class="selectedTabIndex === i ? 'selected' : ''"
            @click="selectTab(i)"
          >
            <!-- <div class="p">
              <IconBase w="15" h="15" viewBox="0 0 15 15" iconName="Arrow-Right">
                <IconUser />
              </IconBase>
            </div> -->
            <span class="tt-up tab-title">{{ tab.title }}</span>
            <div v-show="!showForm" class="tab-desc mute d-f fd-c ai-c tt-up">
              <!-- <span class="dark-grey">—</span> -->
              <span>{{ tab.description ? tab.description : '' }}</span>
            </div>
            <div v-show="!showForm" class="btn-icon p of-h">
              <span class="ani-arrow-right">
                <IconBase w="15" h="15" viewBox="0 0 15 15" iconName="Arrow-Right">
                  <IconArrowRight />
                </IconBase>
              </span>
            </div>
          </div>
        </div>

        <!-- forms are only shown after user selects a tab -->
        <div class="w-100" v-if="showForm">
          <SignIn
            v-if="selectedTabIndex === 1 && forSubmitDemoModal"
            :for-submit-demo-modal="true"
            ref="signInFormRef"
          />
          <SignUp
            v-else
            :type="tabs[selectedTabIndex]?.type || 'artist'"
            :for-submit-demo-modal="forSubmitDemoModal"
            ref="signUpFormRef"
          />
          <div v-if="forSubmitDemoModal" class="d-f fd-c ai-c p">
            <p v-if="selectedTabIndex === 0" class="grey">Already have an account?</p>
            <p v-else class="grey">Don't have an account?</p>
            <div
              class="tt-up text-link"
              @click="selectedTabIndex === 0 ? selectTab(1) : selectTab(0)"
            >
              {{ selectedTabIndex === 0 ? 'Login' : 'Create account' }}
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import SignUp from "@/components/settings/SignUp.vue";
import SignIn from "@/components/settings/SignIn.vue";
import IconBase from "@/assets/icons/IconBase.vue";
import IconArrowRight from "@/assets/icons/IconArrowRight.vue";
import IconArrowLeft from "@/assets/icons/IconArrowLeft.vue";
import IconUser from "@/assets/icons/IconUser.vue";

export default {
  name: "SignUpTabs",
  components: {
    IconBase,
    IconArrowRight,
    IconArrowLeft,
    SignIn,
    SignUp,
    IconUser,
  },
  props: {
    forSubmitDemoModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedTabIndex: this.forSubmitDemoModal ? 0 : null, // artist preselected for submit demo
      showForm: !!this.forSubmitDemoModal, // show artist form immediately for submit demo
      tabs: [
        {
          title: this.forSubmitDemoModal ? "Create Profile" : "Artist Account",
          description: "I make music",
          type: "artist",
        },
        {
          title: this.forSubmitDemoModal ? "Login" : "Label Account",
          description: "I represent artists",
          type: "label",
        },
      ],
    };
  },
  // components: {
  //   SignIn,
  //   SignUp,
  // },
  methods: {
    selectTab(i) {
      this.selectedTabIndex = i;
      this.showForm = true;
    },
    goBackToSelection() {
      this.showForm = false;
      this.$refs.signUpFormRef?.resetForm && this.$refs.signUpFormRef.resetForm();
      this.$refs.signInFormRef?.resetForm && this.$refs.signInFormRef.resetForm();
    },
    formSubmitted() {
      // only call refs when the form is visible/instantiated
      this.$refs.signInFormRef?.login && this.$refs.signInFormRef.login();
      this.$refs.signUpFormRef?.register && this.$refs.signUpFormRef.register();
    },
  },
  watch: {
    selectedTabIndex() {
      // reset child forms when user picks a different tab
      this.$refs.signInFormRef?.resetForm && this.$refs.signInFormRef.resetForm();
      this.$refs.signUpFormRef?.resetForm && this.$refs.signUpFormRef.resetForm();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/_classes.scss";
@import "@/scss/_mixins.scss";
.tabs-padding-y {
  padding-top: calc(#{$nav-height} * 2);
  padding-bottom: calc(#{$nav-height} * 2);
}
.big-select-buttons {
  $fill-height: calc(100vh - calc(#{$nav-height} * 4));
  height: $fill-height;
  min-height: $fill-height;
  max-height: $fill-height;
  align-items: stretch;
  .tab {
    height: 100%;
    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: center;
    // background-color: $card-bg-color;
    // border: 1px solid $line-color;
    // border-radius: 8px;
    &:after {background: transparent !important;}
    &:not(:last-child) {
      border-right: 1px solid $line-color;
    }
    &:hover {
      // background-color: $dark-grey;
      background-color: $card-bg-color;
      // border: 1px solid $brand-hl;
      .ani-arrow-right {
        animation: tab-arrow-slide-loop 0.6s ease forwards;
      }
    }
    .btn-icon {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .tab-desc {
      max-width: 200px;
    }
  }
}
@media #{$mobile} {
  .big-select-buttons {
    flex-direction: column;
    .tab {
      padding: 20px;
      min-height: 200px;
      &:not(:last-child) {
        border-right: none;
        border-bottom: 1px solid $line-color;
      }
    }
  }
}

.back-button {
  padding: 0.25rem;
  background: transparent;
  border: none;
  cursor: pointer;
  color: inherit;
  &:hover {
    opacity: 0.8;
  }
}
</style>